

import RequestCustomerCorrectionButton from './request.customer.correction.button.component';
import stepsSolicitation from '../../domain/constant/steps.solicitation.constant';

import loginService from '../../domain/services/login.service';
import { useTour } from '../../context/tourContext';
import { tours } from '../../domain/constant/tour.constant';
import Row from "../shared/grid/Row";
import Col from "../shared/grid/Col";
import CustomerRequestFavoriteButton from "./customer/customer.request.favorite.button";
import RequestFilingPanel from "./filing/request.filing.panel";

export default function RequestDetailsActionButtons({
    mainRequestId, request, setAlert, refresh, isSmall, setAllowNext, tutorial
}) {

    const { registerRef } = useTour();

    const correctionRef = registerRef(tours.concludedRequestTour, 'correction');

    const showCorrectionButton = loginService.isCustomer() && request.status === stepsSolicitation.CONCLUDED;
    const showFavoriteButton = request.correspondentId;

    // Protocolo pela Facilita (F85) e o registro da data do protocolo feito pelo cliente.
    const showFilingPanel = loginService.isCustomer() && request.status === stepsSolicitation.CONCLUDED;

    const isShowingAButton = showCorrectionButton || showFavoriteButton;

    return (
        <Row gutter={[24, 24]} className={`text-base ${isShowingAButton ? 'mt-6' : 'mt-0'}`}>
            {showCorrectionButton && (
                <Col span={24}>
                    <div ref={correctionRef}>
                        <RequestCustomerCorrectionButton
                            request={request}
                            setAlert={setAlert}
                            onSendToCorrection={refresh}
                            setAllowNext={setAllowNext}
                            tutorial={tutorial}
                        />
                    </div>
                </Col>
            )}
            {/* Depois do Solicitar ajuste: o protocolo não compete com o pedido de correção. */}
            {showFilingPanel && (
                <Col span={24}>
                    <RequestFilingPanel request={request} setAlert={setAlert} refresh={refresh} />
                </Col>
            )}
            {showFavoriteButton && (
                <Col span={24} md={12} lg={12} xl={12}>
                    <CustomerRequestFavoriteButton
                        requestData={request}
                        setAlert={setAlert}
                    />
                </Col>
            )}
        </Row>


    );
}